<script>
    import greenCheckmark from '../../assets/gold_rush/green_checkmark.png?format=webp;jpg';
    import {goTo, range} from "../../utils.js";
    import {adventCalendarEvent, currentAdventClaimed, endExpiredSession, isSessionExpired} from "../../stores.js";
    import ItemsListing from "../ItemsListing.svelte";
    import {_} from "svelte-i18n";
    import {claim_gold_rush_route, game_name} from "../../constants.js";
    import Loader from "../Loader.svelte";
    import {resourceDetails} from "../../globals.js";
    import {onMount} from "svelte";
    import {adventVariant} from "../advent-variant.js";

    let { globals = {} } = $props();

    // Which artwork set this event uses (see advent-variant.js).
    let variant = $derived(adventVariant($adventCalendarEvent.uniqueIdentifier));

    let greenCheckmarkImage = greenCheckmark;
    let processing = $state(false);
    let errorMessage = $state(undefined);

    // ===  Want each of 24 calendar doors to open only if number matches today's date or earlier:

    // Given date string
    const dateString = $adventCalendarEvent.startAt;

    // Parse the date string into a Date object
    const eventStartDate = new Date(dateString);

    // Check if eventStartDate is a valid date
    if (isNaN(eventStartDate.getTime())) {
        throw new Error("Invalid event start date");
    }

    // Get the current date
    const currentDate = new Date();

    // Check if currentDate is a valid date
    if (isNaN(currentDate.getTime())) {
        throw new Error("Invalid current date");
    }

    // Create dates at midnight UTC for accurate day comparison
    const eventStartUTC = Date.UTC(eventStartDate.getUTCFullYear(), eventStartDate.getUTCMonth(), eventStartDate.getUTCDate());
    const currentUTC = Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate());

    // Calculate the difference in time (milliseconds)
    const timeDifference = currentUTC - eventStartUTC;

    // Convert the time difference from milliseconds to days (which day of the event we're on)
    const dayDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24)) + 1;

    // Get today's actual calendar day
    const todaysCalendarDay = currentDate.getDate();

    // Get the start calendar day
    const startCalendarDay = eventStartDate.getDate();

    // Calculate current prize index (1-based) based on day difference
    let currentPrize = $state(dayDifference);
    let currentPrizeItems = $state(undefined);
    let modalOpen = $state(false);
    let modalDate = $state('');

    // Door numbering: default to incremental sequence (1, 2, 3, ...) for all events.
    // Flip to true to render the actual calendar day on each door instead (exception kept for legacy/special events).
    const USE_CALENDAR_DAY_NUMBERS = false;

    // Helper function to get calendar day for a given prize index
    function getCalendarDayForPrize(prizeIndex) {
        // prizeIndex is 1-based (1, 2, 3...)
        // Add (prizeIndex - 1) days to the start date to get the calendar day
        const prizeDate = new Date(Date.UTC(
            eventStartDate.getUTCFullYear(),
            eventStartDate.getUTCMonth(),
            eventStartDate.getUTCDate() + (prizeIndex - 1)
        ));
        return prizeDate.getUTCDate();
    }

    // Helper function to get formatted date for a given prize index
    function getFormattedDateForPrize(prizeIndex) {
        // prizeIndex is 1-based (1, 2, 3...)
        // Add (prizeIndex - 1) days to the start date to get the full date
        const prizeDate = new Date(Date.UTC(
            eventStartDate.getUTCFullYear(),
            eventStartDate.getUTCMonth(),
            eventStartDate.getUTCDate() + (prizeIndex - 1)
        ));

        // Format as "DD Month" (e.g., "27 November")
        const day = prizeDate.getUTCDate();
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];
        const month = monthNames[prizeDate.getUTCMonth()];

        return `${day} ${month}`;
    }

    let claimed = $state(undefined);
    currentAdventClaimed.subscribe(value => {
        claimed = value;
    });

    // Function to toggle the claimed status
    function toggleClaimed() {
        currentAdventClaimed.update(value => !value);
    }

    onMount(() => {
        let destroyed = false;
        let timeoutId = setTimeout(function () {
        if (destroyed) return;

        // ===  Get the modal popup box + content + close span

        const modal = document.getElementById('modalPopup');
        if (!modal) return;


        // === no hover action if higher than today's date (add class 'no-hover')

        function noHover() {

            const prizeIndex = parseInt(this.parentNode.getAttribute('data-prize-index'), 10);

            console.log('prizeIndex:', prizeIndex);
            console.log('dayDifference:', dayDifference);

            if (prizeIndex > dayDifference) {
                this.parentNode.classList.add("no-hover");
            }

        }

        // === door-front: hover + click events

        const doorFronts = document.querySelectorAll(".front");

        for (let i = 0; i < doorFronts.length; i++) {
            // doorFronts[i].addEventListener("mouseover", noHover);
            doorFronts[i].addEventListener("click", clickFront);
        }

        // === door-back: click event

        const doorBacks = document.querySelectorAll(".back");

        for (let i = 0; i < doorBacks.length; i++) {
            doorBacks[i].addEventListener("click", clickBack);
        }

        // === door-front: click toggles class 'open'

        function clickFront() {

            const prizeIndex = parseInt(this.parentNode.getAttribute('data-prize-index'), 10);
            // console.log(prizeIndex);

            if (prizeIndex === dayDifference) {
                this.parentNode.classList.toggle("open");
                clickBack.call(this, prizeIndex);
                currentPrize = prizeIndex;
                collectAdvent();
            }

        }

        // === door-back: click opens the modal + displays corresponding content

        function clickBack(prizeIndexArg) {
            let prizeIndex;

            // Check if this is being called with explicit arguments (from clickFront)
            if (typeof prizeIndexArg === 'number') {
                prizeIndex = prizeIndexArg;
            } else {
                // Called as event handler from clicking the back directly
                prizeIndex = parseInt(this.parentNode.getAttribute('data-prize-index'), 10);
            }

            // Get the formatted date for this prize
            const formattedDate = getFormattedDateForPrize(prizeIndex);

            // console.log('prizeIndex:', prizeIndex);
            // console.log('formattedDate:', formattedDate);

            // show modal with formatted date
            modalOpen = true;
            modalDate = formattedDate;

            // can toggle door closed again IF want to: //
            // this.parentNode.classList.toggle("open");

            currentPrizeItems = $adventCalendarEvent.prizes[`prize${prizeIndex}`]?.items || [];
        }


        // Modal close is now handled declaratively in the template

        Object.keys($adventCalendarEvent.claimablePrizes).forEach(prizeKey => {
            const match = prizeKey.match(/\d+/); // Extract numbers from the key
            if (match) {
                const prizeNumber = match[0]; // Get the first match (the number)

                // Construct the selector for the .dayX .front element
                const selector = `.calendar-grid .day${prizeNumber} .front`;

                // Find the element using the constructed selector
                const frontElement = document.querySelector(selector);

                if (frontElement) {
                    // Toggle the "open" class on the parent node of the .front element
                    frontElement.parentNode.classList.toggle("open");
                }
            }
        });
        }, 250);

        return () => {
            destroyed = true;
            clearTimeout(timeoutId);
        };
    });

    // svelte-ignore state_referenced_locally
    globals.resourceDetails = resourceDetails;
    // svelte-ignore state_referenced_locally
    globals.formatTimeFriendly = formatTimeFriendly;

    function formatTimeFriendly(seconds) {
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let days = Math.floor(hours / 24);

        let timeString = `${minutes} ${$_('Minute')}`;

        if (seconds - 1 > 60 * 60 * 24) {
            timeString = `${days} ${$_('Days')}`;
        } else if (seconds > 60 * 60) {
            timeString = `${hours} ${$_('Hours')}`;
        } else if (seconds >= 60) {
            timeString = `${minutes} ${$_('Minutes')}`;
        }

        return timeString;
    }

    async function collectAdvent() {
        try {
            processing = true;
            const response = await fetch(claim_gold_rush_route, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    prizeId: currentPrize,
                    eventId: $adventCalendarEvent.id,
                }),
            });

            // A 403 is web-shop's LoggedInGuard (see GoldRushPack.svelte): the session is gone, not
            // the prize claimed. Clear it so <Login/> takes over.
            if (isSessionExpired(response)) {
                endExpiredSession(claim_gold_rush_route);
                return;
            }

            if (response.status >= 500) {
                errorMessage = 'The server is busy right now, please try claiming your prize later';
                return;
            }

            if (!response.ok) {
                errorMessage = `An error has occurred: ${response.status}`;
                Rollbar.error("Advent calendar claim failed: " + response.status);
                return;
            }

            const res = await response.text();
            toggleClaimed();

        } catch (error) {
            if (error instanceof TypeError) {
                Rollbar.info("Advent calendar network failure: " + error);
            } else {
                Rollbar.error("Advent calendar unexpected error: " + error);
            }
            errorMessage = 'Connection issue — please check your internet and try again';
        } finally {
            processing = false;
        }
    }

    if (localStorage.getItem("adventCalendarSeen") === null) {
        localStorage.setItem("adventCalendarSeen", "true");
    }

    let prizes = $derived(Object.values($adventCalendarEvent.prizes));
    $effect(() => { currentPrizeItems = $adventCalendarEvent.prizes[`prize${currentPrize}`]?.items || []; });

    onMount(() => {
        goTo('/supplies/adventCalendar', true);
    });
</script>

<div class="adventCalendar">
    <!-- CALENDAR DOORS -->

    <section class="calendar-grid">

        <div class="title">
            <div class="title-lines-container">
                <img alt={game_name} class="logo" src="/images/logo.png" title={game_name}/>
                {#if variant === 'april'}
                    <img alt="{game_name} advent calendar" class="adventTitle"
                         src="/images/adventCalendar/title_april.png"
                         title="{game_name} april event calendar"/>
                {:else if variant === 'sept'}
                    <img alt="{game_name} advent calendar" class="adventTitle"
                         src="/images/adventCalendar/title_sept.png"
                         title="{game_name} Maryland event calendar"/>
                {:else if variant === 'july'}
                    <img alt="{game_name} advent calendar" class="adventTitle"
                         src="/images/adventCalendar/title_july.png"
                         title="{game_name} world cup event calendar"/>
                {:else}
                    <img alt="{game_name} advent calendar" class="adventTitle" src="/images/adventCalendar/title.png"
                         title="{game_name} advent calendar"/>
                {/if}
            </div><!-- closes title-lines-container -->
            <p class="title-intro">Enjoy daily celebrations packed with surprises! Each day, click a button to unveil
                your
                rewards. <b>Check back daily to see what's on!</b></p>
        </div><!-- closes title -->

        {#each range(prizes.length, 1) as prizeIndex}
            {@const calendarDay = getCalendarDayForPrize(prizeIndex)}
            {#if prizeIndex > prizes.length}
                <div class="day{prizeIndex}"></div>
            {:else}
                <div class="day{prizeIndex} day">
                    <div
                            class="door {variant === 'april' ? 'aprilAdvent' : ''} {variant === 'sept' ? 'septAdvent' : ''} {variant === 'july' ? 'julyAdvent' : ''} {prizeIndex !== dayDifference ? 'no-hover' : ''} {prizeIndex < dayDifference ? 'faded' : ''} {prizes[prizeIndex - 1].specialType ? 'special' : ''} {prizeIndex === dayDifference ? 'current' : ''} {$currentAdventClaimed && prizeIndex === dayDifference ? 'open' : ''}"
                            data-prize-index={prizeIndex}
                            data-calendar-day={calendarDay}
                    >
                        <div class="front">{USE_CALENDAR_DAY_NUMBERS ? calendarDay : prizeIndex}</div>
                        <div class="back">
                            <ItemsListing
                                    storePack={{}}
                                    goldAmount={0}
                                    globals={globals}
                                    items={prizes[prizeIndex - 1].items}
                                    hasMask={false}
                            />
                            <picture class="greenCheckmark">
                                <source srcset={greenCheckmarkImage[0]} type="image/webp"/>
                                <source srcset={greenCheckmarkImage[1]} type="image/jpg"/>
                                <img alt="Green Checkmark" src={greenCheckmarkImage[0]}/>
                            </picture>
                        </div>
                    </div>
                </div>
            {/if}
        {/each}

    </section><!-- closes calendar-grid -->

    <!-- MODAL POPUP BOX -->

    <!-- svelte-ignore a11y_interactive_supports_focus -->
    <div id="modalPopup" class="modal" style:display={modalOpen ? 'block' : 'none'} onclick={(e) => { if (e.target === e.currentTarget) modalOpen = false; }} onkeydown={(e) => { if (e.key === 'Escape') modalOpen = false; }} role="dialog">

        <!-- MODAL CONTENT -->

        <div class="modalContent">

            <button type="button" class="close" onclick={() => modalOpen = false}>&times;</button>
            <h3 class="dailyDate"><span>{modalDate}</span></h3>
            {#if processing}
                <Loader/>
            {:else}
                {#if errorMessage}
                    <p>{errorMessage}</p>
                {:else}
                    <h4 class="dailyTitle">You have claimed:</h4>
                    {#key currentPrizeItems}
                        <ItemsListing storePack={{}} goldAmount={0} globals={globals} items={currentPrizeItems}
                                      hasMask={false}/>
                    {/key}
                {/if}
            {/if}
        </div><!-- closes modalContent -->

    </div><!-- closes modalPopup -->
</div>

<style lang="scss">
  @use 'sass:math';
  @use '../../styles/vars.scss' as *;

  :global {
    .adventCalendar {
      display: flex;
      justify-content: center;
      align-items: center;

      /* === SCSS COLOUR VARIABLES === */

      $backgroundteal: #266c8e;
      $textteal: #0a5656;
      $borderpink: #96e3ff;
      $textpink: #96e3ff;
      $darkslate: #344f63;
      $doorback: #135270;
      $titlebackground: #ffffff;
      $numbers: #ffffff;
      $linkbuttonhover: #2883af;

      /* SCSS RESPONSIVE TITLE TYPE @MIXIN */

      /// Viewport sized typography with minimum and maximum values
      /// @author Eduardo Boucas (@eduardoboucas)
      ///
      /// @param {Number}   $responsive  - Viewport-based size
      /// @param {Number}   $min         - Minimum font size (px)
      /// @param {Number}   $max         - Maximum font size (px)
      ///                                  (optional)
      /// @param {Number}   $fallback    - Fallback for viewport-
      ///                                  based units (optional)
      ///
      /// @example scss - 5vw font size (with 50px fallback),
      ///                 minumum of 35px and maximum of 150px
      /// @include responsive-font(5vw, 35px, 150px, 50px);

      @mixin responsive-font($responsive, $min, $max: false, $fallback: false) {
        $responsive-unitless: math.div($responsive, $responsive - $responsive + 1);
        $dimension: 'width';
        @if math.unit($responsive) == 'vh' {
          $dimension: 'height';
        }
        $min-breakpoint: math.div($min, $responsive-unitless) * 100;

        @media (max-#{$dimension}: #{$min-breakpoint}) {
          font-size: $min;
        }

        @if $max {
          $max-breakpoint: math.div($max, $responsive-unitless) * 100;

          @media (min-#{$dimension}: #{$max-breakpoint}) {
            font-size: $max;
          }
        }

        @if $fallback {
          font-size: $fallback;
        }

        font-size: $responsive;
      }

      /* =============================== */

      body {
        background-color: $backgroundteal;
        background-position: center center;
        background-repeat: no-repeat, repeat;
        background-size: 120vw;
        font-family: 'Montserrat', Verdana;
      }

      /* === MOBILE-FIRST GRID LAYOUT === */

      .calendar-grid {
        display: grid;
        width: 96%;
        max-width: 900px;
        margin: 2% auto;
        margin-top: 0;

        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;
        gap: 10px 0;

        grid-template-areas:    "title    title"
                                "day1     day2"
                                "day3     day4"
                                "day5     day6"
                                "day7     day8"
                                "day9     day10"
                                "day11    day12"
                                "day13    day14"
                                "day15    day16"
                                "day17    day18"
                                "day19    day20"
                                "day21    day22"
                                "day23    day24";
      }

      @media only screen and (min-width: 380px) {
        .calendar-grid {
          grid-template-columns: repeat(3, 1fr);
          grid-template-areas:    "title      title     title"
                                  "day1       day2      day3"
                                  "day4       day5      day6"
                                  "day7       day8      day9"
                                  "day10      day11     day12"
                                  "day13      day14     day15"
                                  "day16      day17     day18"
                                  "day19      day20     day21"
                                  "day22      day23     day24";
        }
      }

      @media only screen and (min-width: 505px) {
        .calendar-grid {
          grid-template-columns: repeat(4, 1fr);
          grid-template-areas:    "title      title     title     title"
                                  "day1       day2      day3      day4"
                                  "day5       day6      day7      day8"
                                  "day9       day10     day11     day12"
                                  "day13      day14     day15     day16"
                                  "day17      day18     day19     day20"
                                  "day21      day22     day23     day24";
        }
      }

      @media only screen and (min-width: 625px) {
        .calendar-grid {
          grid-template-columns: repeat(5, 1fr);
          grid-template-areas:    "title      title     title     title      title"
                                  "title      title     title     title      title"
                                  "title      title     title     title      title"
                                  "day1       day2      day3      day4       day5"
                                  "day6       day7      day8      day9       day10"
                                  "day11      day12     day13     day14      day15"
                                  "day16      day17     day18     day19      day20"
                                  "day21      day22     day23     day24      day25";
        }
      }

      /* MEDIA QUERY -- DESKTOP LAYOUT */

      @media only screen and (min-width: 870px) {
        .calendar-grid {
          grid-template-columns: repeat(7, 1fr);
          grid-template-areas:    "title      title     title     title      title      title      title"
                                  "title      title     title     title      title      title      title"
                                  "title      title     title     title      title      title      title"
                                  "day1       day2      day3      day4       day5       day6       day7"
                                  "day8       day9      day10     day11      day12      day13      day14"
                                  "day15      day16     day17     day18      day19      day20      day21"
                                  "day22      day23     day24     day25      day26      day27      day28";
        }
      }

      /* === INDIVIDUAL GRID ITEMS ===  */

      .title {
        grid-area: title;
        text-align: center;
        color: $textteal;
      }

      .title-lines-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 130px;

        .logo {
          width: 225px;
        }

        .adventTitle {
          width: 475px;
          margin-left: -170px;
        }
      }

      .bigger-text {
        @include responsive-font(3.5vw, 26px, 50px, 40px);
      }

      .title-intro {
        font-family: var(--font-family-sans-condensed);
        color: rgb(216, 183, 130);
        margin-top: 10px;
      }

      .day {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .day1 {
        grid-area: day1;
      }

      .day2 {
        grid-area: day2;
      }

      .day3 {
        grid-area: day3;
      }

      .day4 {
        grid-area: day4;
      }

      .day5 {
        grid-area: day5;
      }

      .day6 {
        grid-area: day6;
      }

      .day7 {
        grid-area: day7;
      }

      .day8 {
        grid-area: day8;
      }

      .day9 {
        grid-area: day9;
      }

      .day10 {
        grid-area: day10;
      }

      .day11 {
        grid-area: day11;
      }

      .day12 {
        grid-area: day12;
      }

      .day13 {
        grid-area: day13;
      }

      .day14 {
        grid-area: day14;
      }

      .day15 {
        grid-area: day15;
      }

      .day16 {
        grid-area: day16;
      }

      .day17 {
        grid-area: day17;
      }

      .day18 {
        grid-area: day18;
      }

      .day19 {
        grid-area: day19;
      }

      .day20 {
        grid-area: day20;
      }

      .day21 {
        grid-area: day21;
      }

      .day22 {
        grid-area: day22;
      }

      .day23 {
        grid-area: day23;
      }

      .day24 {
        grid-area: day24;
      }

      .day25 {
        grid-area: day25;
      }

      .day26 {
        grid-area: day26;
      }

      .day27 {
        grid-area: day27;
      }

      .day28 {
        grid-area: day28;
      }

      /* ===  DOOR STYLES ===  */

      .calendar-grid input {
        display: none;
      }

      .door {
        //width: 100%;
        //height: 100%;
        perspective: 1000px;
        transform-style: preserve-3d;
        transition: all 300ms;
        border-radius: 10px;
        cursor: pointer;
        width: 110px;
        height: 108px;
        font-family: var(--font-family-sans-condensed);
        font-size: 48px;
        font-weight: bold;
        color: $numbers;
        background-image: url('/images/adventCalendar/default.png');
        background-size: cover;

        &.no-hover {
          cursor: default;
          pointer-events: none;

          &.open {
            cursor: pointer;
            pointer-events: auto;

            &:hover {
              .back {
                filter: brightness(1.1);
              }
            }
          }
        }

        &:not(.no-hover):hover {
          .front, .back {
            filter: brightness(1.1);
          }
        }

        &.faded {
          opacity: 0.5;

          .back {
            display: none;
          }

          &.open {
            opacity: 1;

            .back {
              display: block;
            }
          }
        }

        &.current {
          background-image: url('/images/adventCalendar/current.png');
          color: rgb(102, 216, 9);
        }

        &.special {
          background-image: url('/images/adventCalendar/special.png');
          color: rgb(255, 180, 0);
        }

        &.aprilAdvent {
          background-image: url('/images/adventCalendar/default_april.png');

          &.current {
            background-image: url('/images/adventCalendar/current_april.png');
            color: rgb(102, 216, 9);
          }

          &.special {
            background-image: url('/images/adventCalendar/special_april.png');
            color: rgb(255, 180, 0);
          }

          .back {
            background-image: url('/images/adventCalendar/claimed_april.png') !important;
          }
        }

        &.septAdvent {
          background-image: url('/images/adventCalendar/default_sept.png');

          &.current {
            background-image: url('/images/adventCalendar/current_sept.png');
            color: rgb(102, 216, 9);
          }

          &.special {
            background-image: url('/images/adventCalendar/special_sept.png');
            color: rgb(255, 236, 191);
          }

          &.current.special {
            background-image: url('/images/adventCalendar/current_sept.png');
            color: rgb(255, 236, 191);
          }

          .back {
            background-image: url('/images/adventCalendar/claimed_sept.png') !important;
          }
        }

        &.julyAdvent {
          height: 110px;
          background-image: url('/images/adventCalendar/default_july.png');

          &.current {
            background-image: url('/images/adventCalendar/current_july.png');
            color: rgb(102, 216, 9);
          }

          &.special {
            background-image: url('/images/adventCalendar/special_july.png');
            color: rgb(255, 180, 0);
          }
        }
      }

      .door div {
        position: absolute;
        height: 100%;
        width: 100%;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .door .back {
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url('/images/adventCalendar/claimed.png');
        transform: rotateY(180deg);

        picture {
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            position: absolute;
            top: 45px;
            left: 50px;
          }
        }

        .items {
          background: none;
          margin: 0;
          border-radius: 6px;
          z-index: -1;

          .item {
            justify-content: center;
            height: 90px;
            pointer-events: none;

            .item-icon {
              width: 90px;
              height: 90px;
              max-width: 90px;
              max-height: 90px;

              &:after {
                max-width: 90px;
              }
            }

            .item-title, .item-amount {
              display: none;
            }
          }
        }

        .items > div > *:not(:first-child) {
          display: none;
        }
      }

      .open {
        transform: rotateY(180deg);
      }

      /* ===  MODAL (BACKGROUND) ===  */

      .modal {
        display: none; /* Hidden by default */
        position: fixed;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
      }

      /* === MODAL CONTENT + BOX ===  */

      .modalContent {
        background-color: rgb(240, 214, 166);
        margin: 15% auto;
        padding: 20px 20px 30px;
        border-radius: 6px;
        width: 76%;
        max-width: 600px;
        min-height: 200px;
        letter-spacing: 0.5px;
        line-height: 1.4em;

        p {
          font-size: 0.9em;
        }

        .items {
          //background: none;
          margin: 0;

          .item {
            //display: flex;
            //justify-content: center;
            //align-items: center;
            //flex-wrap: wrap;

            .item-icon {
            }

            .item-title {
              //flex-grow: 0;
            }

            .item-amount {
            }

            .item-title, .item-amount {
              font-size: 22px;
              font-family: var(--font-family-sans-condensed);
              color: rgb(76, 32, 12);
              font-weight: bold;
            }
          }
        }

        .loader {
          top: 50px !important;
          position: relative !important;
        }
      }

      .dailyTitle {
        font-family: var(--font-family-sans-condensed);
        font-size: 20px;
        color: rgba(55, 29, 17, 0.502);
      }

      .dailyDate {
        font-family: var(--font-family-sans-condensed);
        font-size: 28px;
        height: 40px;
        background-image: url('/images/adventCalendar/modal_title_background.png');
        background-size: cover;
        color: rgb(255, 249, 227);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 0;
        position: relative;
        top: -16px;
        left: -16px;

        span {
          position: relative;
          left: 15px;
        }
      }

      .highlight {
        font-weight: bold;
        color: rgb(76, 32, 12);
      }

      /* ===  MODAL CLOSE BUTTON (X) ===  */

      .close {
        color: black;
        float: right;
        font-size: 48px;
        line-height: 26px;
        font-weight: bold;
        position: relative;
        top: -10px;
        background: none;
        border: none;
        padding: 0;

        &:hover,
        &:focus {
          opacity: 0.8;
          text-decoration: none;
          cursor: pointer;
        }
      }

      @media only screen and (max-width: 519px) {
        .title-line1 {
          @include responsive-font(10vw, 34px, 52px, 38px);
        }
        .title-line2 {
          @include responsive-font(8vw, 27px, 48px, 35px);
        }
        .bigger-text {
          @include responsive-font(10vw, 32px, 52px, 40px);
        }
        .title-lines-container {
          .logo {
            width: 175px;
          }

          .adventTitle {
            width: 325px;
            margin-left: -120px;
          }
        }
      }

      @media only screen and (max-width: 375px) {
        .title-lines-container {
          height: 80px;

          .logo {
            width: 135px;
          }

          .adventTitle {
            width: 285px;
            margin-left: -100px;
          }
        }

        .dailyDate {
          font-size: 18px;
        }

        .dailyTitle {
          font-size: 16px;
        }

        .item-title, .item-amount {
          font-size: 14px !important;
        }
      }

      @media only screen and (max-width: 690px) {
        .modalContent {
          position: relative;
          top: 70px;
        }

        .door {
          font-size: 46px;
        }
      }

      @media only screen and (max-width: 300px) {
        .title-lines-container {
          height: 50px;

          .logo {
            width: 85px;
          }

          .adventTitle {
            width: 195px;
            margin-left: -50px;
          }
        }

        .dailyDate {
          background: none;
          color: rgb(76, 32, 12);
        }

        .modalContent {
          position: relative;
          top: 90px;
        }
      }

    }
  }
</style>
